import { useQuery } from 'react-query'

import { QueryCacheKey } from '~shared-components/utils/enums'

import { fetchSalesGroups, Filters } from '../api/sales-groups'

interface UseSalesGroupsParameters extends Filters {
  isEnabled?: boolean
}

export const useSalesGroups = ({
  distributionChannels,
  divisions,
  ids,
  isEnabled = true,
  salesOrganizations,
}: UseSalesGroupsParameters) => {
  const queryCacheKey = [
    QueryCacheKey.SalesGroups,
    distributionChannels,
    divisions,
    salesOrganizations,
    ids,
  ]
  const queryFunction = () =>
    fetchSalesGroups({
      distributionChannels,
      divisions,
      ids,
      salesOrganizations,
    })
  const queryOptions = {
    enabled: isEnabled,
  }

  return useQuery(queryCacheKey, queryFunction, queryOptions)
}
